import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
    selector: 'app-agreement-terms',
    standalone: true,
    imports: [CommonModule, TranslatePipe],
    templateUrl: './agreement-terms.page.html',
    styleUrls: ['./agreement-terms.page.scss'],
})
export class AgreementTermsPage { }
